import { digitsEnToFa } from '@persian-tools/persian-tools';
import moment from 'jalali-moment';

/** «یکشنبه ۲۶ مهر، ساعت ۱۰:۲۰» — Persian digits in the string itself, not left to the font. */
export const formatVisit = (iso?: string) => (iso ? digitsEnToFa(moment(iso).locale('fa').format('dddd jD jMMMM، [ساعت] HH:mm')) : '');

/** «۱۰:۲۰» */
export const formatClock = (iso?: string) => (iso ? digitsEnToFa(moment(iso).format('HH:mm')) : '');

/** «۲۵ آبان» or, with the year, «۲۵ آبان ۱۴۰۵» */
export const formatDate = (iso?: string, withYear = false) =>
  iso ? digitsEnToFa(moment(iso).locale('fa').format(withYear ? 'jD jMMMM jYYYY' : 'jD jMMMM')) : '';
